import React from 'react';
export function Footer() {
  return <footer className="bg-neutral-900 border-t-4 border-yellow-400 py-10 px-4 text-center" data-id="element-129" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-130" data-mp="3ggtz0kj4bn6a">
        Educational reference material only. Actual machinery operation, practical training and
        competency assessments must follow applicable regulations, qualified supervision and
        equipment-specific manufacturer instructions.
      </p>
      <p className="text-sm text-white/80" data-id="element-131" data-mp="38qw2zmvrtrp">
        © Heavy Equipment Instructor Atlas 2026 — All Rights Reserved.
      </p>
    </footer>;
}